import React from 'react';
import { ChallengeCardsContent, ShimmerEffect } from './styles';

// import { Container } from './styles';

const LoadingStateRightSide: React.FC = () => {
  return (
    <ChallengeCardsContent>
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
      <ShimmerEffect />
    </ChallengeCardsContent>
  );
};

export default LoadingStateRightSide;
